import { useCallback } from 'react';

export interface LogCardActionsProps<T> {
  onDelete?: (logId: string) => void;
  onEdit?: (logId: string, log: T) => void;
}

export interface UseLogCardActionsReturn {
  handleDelete: () => void;
  handleEdit: () => void;
}

export const useLogCardActions = <T extends { id: string }>(
  log: T,
  actions: LogCardActionsProps<T>
): UseLogCardActionsReturn => {
  const handleDelete = useCallback(() => {
    if (actions.onDelete) {
      actions.onDelete(log.id);
    }
  }, [actions.onDelete, log.id]);

  const handleEdit = useCallback(() => {
    if (actions.onEdit) {
      actions.onEdit(log.id, log);
    }
  }, [actions.onEdit, log.id, log]);

  return {
    handleDelete,
    handleEdit
  };
}; 